import React from 'react';
import fanart from '../assets/images/fanart.png';
import zawryzar from '../assets/images/animatic.png';

const CommunityPage = ({ id }) => {
  return (
    <section id={id} className="bg-black/90 py-20">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          {/* Main content */}
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-bold mb-8 tracking-wider uppercase">
              A dedicated, uplifting community
            </h1>
            <p className="text-lg text-white/80 leading-relaxed mb-8">
              The <span className="text-red-500 font-semibold">EPIC</span> community is comprised of over 1.3M people on TikTok, 
              30K people on Discord, and even more across other platforms. This positive and supportive 
              community comes together every day to make fan art, perform song covers, create animatics, 
              and spread the word about <span className="text-red-500 font-semibold">EPIC</span>.
            </p>
            <p className="text-lg text-white/80 leading-relaxed">
              Part of the journey of creating <span className="text-red-500 font-semibold">EPIC</span> has 
              been documented by Jorge Rivera-Herrans on his TikTok account.
            </p>
          </div>

          {/* Image Grid */}
          <div className="grid md:grid-cols-2 gap-8">
            <figure className="w-full">
              <div className="aspect-[4/3] w-full mb-2">
                <img 
                  src={fanart}
                  alt="Fan Art by @mo11sk11 on Instagram"
                  className="w-full h-full object-cover rounded-lg"
                />
              </div>
              <figcaption className="text-center text-white/70 text-sm">
                Fan Art by @mo11sk11 on Instagram
              </figcaption>
            </figure>
            <figure className="w-full">
              <div className="aspect-[4/3] w-full mb-2">
                <img 
                  src={zawryzar}
                  alt="Animatic by @zawryzar on Youtube"
                  className="w-full h-full object-cover rounded-lg"
                />
              </div>
              <figcaption className="text-center text-white/70 text-sm">
                Animatic by @zawryzar on Youtube
              </figcaption>
            </figure>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CommunityPage;